import { combineReducers } from '@reduxjs/toolkit'
import questions from './list.store'

export const rootReducer = combineReducers({
  questions,
})
